import { render, staticRenderFns } from "./ActualITDeclarations.vue?vue&type=template&id=646ea835&scoped=true"
import script from "./ActualITDeclarations.vue?vue&type=script&lang=js"
export * from "./ActualITDeclarations.vue?vue&type=script&lang=js"
import style0 from "./ActualITDeclarations.vue?vue&type=style&index=0&id=646ea835&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646ea835",
  null
  
)

export default component.exports